function smoothScroll() {
  const targets = document.querySelectorAll('a[href^="#"]');

  if (targets.length === 0) {
    return;
  }

  targets.forEach((target) => {
    target.addEventListener('click', (event) => {
      event.preventDefault();

      const href = target.getAttribute('href');
      const scrollStopTarget = document.querySelector(href === '' ? 'html' : href);

      scrollStopTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  });
}

smoothScroll();